var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64.61C4.168 3.452 7.337 5.405 11 5.405c3.663 0 6.833-1.953 8.363-4.795M4.32 2.794L.786 5.756M8.51 5.104L6.81 9.39M17.68 2.794l3.534 2.962M13.483 5.104l1.702 4.286",
    stroke: "#707175",
    strokeWidth: 0.833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDisabled;